import HiddenField from '../../../../../components/HiddenField/HiddenField';
import BookingParameters from '../../../../types/BookingParameters';
import bookingParameterKeys from '../../helpers/bookingParameterKeys';

type BookingParameterFieldsProps = {
    parameters?: BookingParameters;
};

const BookingParameterFields = ({
    parameters = {},
}: BookingParameterFieldsProps) => (
    <>
        {bookingParameterKeys.map((key) => {
            if (!parameters[key]) {
                return null;
            }

            return <HiddenField key={key} name={key} value={parameters[key]} />;
        })}
    </>
);

export default BookingParameterFields;
